export default __webpack_public_path__ + "static/media/TV_Evangelizar.e85cca51.png";